import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import { getToken, getCurrentUser } from 'utils/storage';
import png1 from "images/preferentialProducts/heart1.png";
import png2 from "images/preferentialProducts/heart2.png";
import NoDataPicture from "components/NoDataPicture";
import { showhtml, getDate } from "utils/methods";
import Bread from '../../components/Breadcrumb';

import {
  Checkbox,
  Form,
  MessageBox,
  Button,
  Message,
  Dialog,
  DatePicker,
  Radio
} from "element-react";
require("./detail2.scss");

export default class Detail extends PureComponent {
  constructor(props) {

    super(props);
    this.state = {
      detail: {
        product:{
          productNumber:'20',
          title:'接种疫苗',
          beginTime:'2021-04-20',
          endTime:'2021-04-30',
          productAddress:'深南大道7028号'
        },
        photoUrl:'http://121.31.6.253:8888/group1/M00/00/7E/wKgKAl6n_w-AZgB7AAB4yp6fC5c965.png'
      },
      productVisible: true,
      time: "",
      active: false,
      tab: 0,
      tabs: [{ propertyValue: ["注意事项12","注意事项112","注意事项212",], propertyName: "注意事项"},{ propertyValue: "注意事项12", propertyName: "体检内容"}],
      tabs1:["注意事项12","注意事项112","注意事项212"],
      tabs2: [],
      collection: {},
      isCheck: false,
      data: [],
      width: 0,
      criterion: [],
      dialogVisible: false,
    };
  }

  componentDidMount = () => {
    this.getList();
  }

  getList() {
    const {
      location: { search }
    } = this.props;
    const id = search.substring(1);
    let params = {
      id: id,
      noHeader:false
    };
    
    let token = getToken();
    console.log(token);

    Http.getProduct(Request.selectProductNameAndValue(), params, token, obj => {
      console.log("obj.data:",obj)
      
      if (obj && obj.code == 200) {
        var placesWidth = obj.data.product
        this.setState({
          detail: obj.data,
          tabs: obj.data.productTwo,
          tabs1: obj.data.productOne,
          productStatus:obj.data.product.productStatus,
          width: 360/Number(placesWidth.productNumberAll)*Number(placesWidth.productNumber),
        });
        if (obj.data.collection != null && obj.data.collection != "") {
          this.setState({ collection: obj.data.collection, active: true });
        }
      }
    });
    const title1="平台服务准则";
    let param = {
      title: title1,
      noHeader:false
    };
    // 获取平台准则
    Http.getProduct(Request.getPing(), param, token, obj => {
      console.log("obj.data22222222222222222222:", obj)
      if (obj && obj.code == 200) {
        this.setState({
          criterion: obj.data,
        });
      }
    });
  }

  readCriterion = () => {
    this.setState({
      dialogVisible: true
    })
  }

  getheart(e) {
    let { active, detail } = this.state;
    let params = {};
    console.log("active", active);
    if (active) {
      //取消收藏操作
      params = {
        productId: detail.product.id,
        type: 0
      };
    } else {
      //收藏
      params = {
        productId: detail.product.id,
        productName: detail.product.title,
        productImg: detail.photoUrl,
        productPrice: detail.product.price,
        type: 1
      };
    }
    let token = getToken();
    console.log("token111",token);
    if(token==null){
      MessageBox.msgbox({
        title: "提示",
        message: "请先登录再收藏！",
        showCancelButton: false,
        confirmButtonText: "关闭"
      });
    }else if(token!=null){
      let params1 = {};
      return Http.post(Request.personaluserInfo(), params1, obj => {
          console.log('obj', obj);
          if (obj.code == 200) {
             if(obj.data.user.userType=="3"){
              MessageBox.msgbox({
                title: "提示",
                message: "服务商不能收藏产品！",
                showCancelButton: false,
                confirmButtonText: "关闭"
              });
             }else if(obj.data.user.authStatus!=1){
              MessageBox.msgbox({
                title: "提示",
                message: "请等待，账户正在审核中",
                showCancelButton: false,
                confirmButtonText: "关闭"
              });
             }else{
              Http.post(Request.saveOrRemoveFavorite(), params, obj => {
                if( obj.data=="用户未登录"){
                  Message({
                    type: "warning",
                    message: "用户未登录,请先登录再收藏!"
                  });
                  return;
                }
                if (obj && obj.code == 200) {
                  console.log("active", obj.data);
                  if (obj.data) {
                    if (active) {
                      this.setState({ active: false }, () => {
                        Message({
                          type: "success",
                          message: "取消成功!"
                        });
                      });
                    } else {
                    
                        this.setState({ active: true }, () => {
                          Message({
                            type: "success",
                            message: "收藏成功!"
                          });
                        });
                 
                    }
                  }
                }else if(obj.code==405){
                  Message.warning(obj.data);
                }
              });
             }
          } else {
              Message.error("登录信息已失效，请重新登录");
             
          }
      });
    }

  }

  changeTabs = idx => {
    console.log(idx);
    this.setState({
      tab: idx,
    });
  };

  signUp() {
    let { detail,isCheck } = this.state;
    let token = getToken();
    console.log("token111",token);
    if (!isCheck) {
      MessageBox.msgbox({
        title: "提示",
        message: "请阅读并同意《平台服务准则》",
        showCancelButton: false,
        confirmButtonText: "关闭"
      });
    } else if(detail.product.productNumberAll == detail.product.productNumber){
      MessageBox.msgbox({
        title: "提示",
        message: "名额已达上限",
        showCancelButton: false,
        confirmButtonText: "关闭"
      });
    }else if(token==null){
      MessageBox.msgbox({
        title: "提示",
        message: "请先登录再报名！",
        showCancelButton: false,
        confirmButtonText: "关闭"
      });
    }else if(token!=null){
      let params = {};
      return Http.post(Request.personaluserInfo(), params, obj => {
          console.log('obj', obj);
          if (obj.code == 200) {
             if(obj.data.user.userType=="3"){
              MessageBox.msgbox({
                title: "提示",
                message: "服务商不能购买产品！",
                showCancelButton: false,
                confirmButtonText: "关闭"
              });
             }else if(obj.data.user.authStatus!=1){
              MessageBox.msgbox({
                title: "提示",
                message: "请等待，账户正在审核中",
                showCancelButton: false,
                confirmButtonText: "关闭"
              });
             }else{
              this.setState({
                productVisible: true
              });
             }
          } else {
              Message.error("登录信息已失效，请重新登录");
             
          }
      });
    }
  }

  check() {
    let { isCheck } = this.state;
    this.setState({
      isCheck: !isCheck
    });
  }

  disabledDate(time) {
    const { detail } = this.state;
    let times = time.getTime();
    let nowDate = new Date().getTime();
    // 活动时间
    let activeBefore = new Date(detail.product.beginTime).getTime();
    let activeAfter = new Date(detail.product.endTime).getTime();
    return (
      times < nowDate || times < activeBefore - 8.64e7 || times > activeAfter
    );
  }

  onProductOk() {
    //关闭弹框
    const { detail, time } = this.state;
    console.log("detail:",detail);
    console.log("time:",time);
    if(time == ''){
      Message('请选择时间');
      console.log("提示不会弹出的话，是因为被弹框遮挡了");
    }else{
      let params = {
        productTypeId: 1,
        productId: detail.product.id,
        productTypeName: "公益服务",
        appointmentTime: getDate(time)
      };
  
      Http.post(Request.saveOrder(), params, obj => {
        console.log("obj111:",obj);
        if (obj && obj.code == 200) {
          this.setState(
            {
              productVisible: false
            },
            () => {
              Message({
                type: "success",
                message: "报名成功!"
              });
            }
          );
        } else if(obj.code==405){
          this.setState(
            {
              productVisible: false
            },
            () => {
              Message.warning(obj.msg);
            }
          );
        } else {
          this.setState(
            {
              productVisible: true
            },
            () => {
              Message({
                type: "error",
                message: "报名失败!"
              });
            }
          );
        }
      });
    }
    
  }

  render() {
    const {
      detail,
      active,
      tabs,
      tab,
      productStatus,
      isCheck,
      time,
      tabs1,
      tabs2,
      criterion
    } = this.state;
  
 
    console.log('detail',detail)
    console.log(showhtml([1,2,3]))
    // console.log('tabs1',tabs1)
    // console.log('productStatus',productStatus)
    return (
      <div className="box">
          <Bread></Bread>

        <div className="container80 clear">
          <div className="detail">
            <div className="detailImgBox">
              <div className="detailImgWrap">
                {detail.photoUrl != "" ? (
                  <img src={detail.photoUrl} />
                ) : (
                  <NoDataPicture className="detailImg" />
                )}
              </div>
              {!productStatus||productStatus==4 ?<span className="heartImg">
                {!active  ? (
                  <div onClick={() => this.getheart()}>
                    <img src={png1} alt="" />
                  </div>
                ) : (
                  <div onClick={() => this.getheart()}>
                    <img src={png2} alt="" />
                  </div>
                )}
                {!active? <span>收藏</span> : <span>取消收藏</span>}
              </span>:''}
            </div>

            <div className="rightCont">
              {detail && detail.product!=''?  <div className="detail_title">{detail.product.title}</div> : null}
              {/* <p>
                    产品标题: {detail && detail.product!=''?  <span>{detail.product.title}</span> : null}
                  </p> */}
                  <p>
                    活动开始时间: {detail && detail.product!=''?  <span>{detail.product.beginTime}</span> : null}
                  </p>
                  <p>
                    活动结束时间: {detail && detail.product!=''?  <span>{detail.product.endTime}</span> : null}
                  </p>
                  <p>
                    服务地点: {detail && detail.product!=''?  <span>{detail.product.productAddress}</span> : null}
                  </p>
              {/* {tabs1.map((item, idx) => {
                return (
                  <p>
                    {item.propertyName}:{item.propertyValue}
                  </p>
                );
              })} */}
              {detail && detail.product!=''? 
                 <div className="places">
                 <div className="round">
                   <div className="rounded" style={{width:this.state.width}}>
                     <span>
                       {detail.product.productNumber} /{detail.product.productNumberAll}
                     </span>
                   </div>
                 </div>
                 <span className="placesTxt">
                   仅限{detail.product.productNumberAll - detail.product.productNumber}个名额
                 </span>
               </div>
              :null}
             
             {!productStatus||productStatus==4 ?   <Button
                type="text"
                className="button"
                onClick={() => this.signUp()}
              >
                立即报名
              </Button>:''
       }
              {!productStatus||productStatus==4 ?   <div className="agreement">
                <Checkbox checked={isCheck} onChange={() => this.check()}>
                  我已阅读并同意{" "}
                </Checkbox>
                <a style={{ cursor: 'pointer' }} onClick={this.readCriterion.bind(this)}>《平台服务准则》</a>
              </div>:''
              }
            </div>
          </div>

          {tabs != [] &&tabs.size!=0? (
            <div className="attention productDetails">
              <ul className='productDetailsUl' >
                {tabs.map((item, idx) => {
                  return (
                    <li
                      key={idx}
                      className={tab === idx ? "active" : ""}
                      onClick={() =>{
                        this.setState({
                          tab: idx,
                        })
                        if(idx){
                          this.setState({
                            tab: idx,
                            tabs1:['3hdad是否合适个嘎嘎嘎好44444',2,35,4,5]
                          })
                        }else{
                          console.log(this.state.tabs1)
                          this.setState({
                            tabs1:["注意事项12","注意事项112","注意事项212"]
                  
                          })
                        }
                      }
                      }
                    >
                      {item.propertyName}
                    </li>
                    
                  );
                })}
                
              </ul>
              <od className='productDetailsChildren'>
                
                {tabs1.map((item,index)=>{
                  return(
                    <li key={index}>
                      {`${index+1},${item}`}
                    </li>
                  )
                })}
              </od>
                <li>
                  {showhtml(tabs[tab].propertyValue)}
                </li>
            </div>
          ) : null}
        </div>
        <Dialog
          title="选择时间"
          size="tiny"
          visible={this.state.productVisible}
          onCancel={() => this.setState({ productVisible: false })}
          lockScroll={false}
          customClass="dialog_out"
        >
          <Dialog.Body>
            <Form labelWidth="120">
              <Form.Item label="活动时间:">
                {detail && detail.product.beginTime} 至 {detail && detail.product.endTime}
              </Form.Item>
              <Form.Item label="预约体检时间:" labelWidth="120" required={true}>
                <DatePicker
                  value={this.state.time}
                  placeholder="选择日期"
                  disabledDate={(Date, selectionMode) =>
                    this.disabledDate(Date)
                  }
                  onChange={date =>
                    this.setState({
                      time: date
                    })
                  }
                />
              </Form.Item>
            </Form>
          </Dialog.Body>

          <Dialog.Footer className="dialog-footer">
            <Button
              style={{ borderColor: "#18388c", color: "#18388c" }}
              onClick={() => this.setState({ productVisible: false })}
            >
              取消
            </Button>
            <Button
              style={{
                background: "#18388c",
                borderColor: "#18388c",
                color: "#fff",
                borderRadius: "8px"
              }}
              onClick={() => this.onProductOk()}
            >
              确定
            </Button>
          </Dialog.Footer>
        </Dialog>

        <Dialog
          className="criterionDialog"
          visible={this.state.dialogVisible}
          onCancel={() => this.setState({ dialogVisible: false })}
        >
          <Dialog.Body>
            <div className="criterion_title">{criterion.title}</div>
            <div className="criterion_cont">{showhtml(criterion.content)}</div>
          </Dialog.Body>
          <Dialog.Footer className="dialog-footer">
            <Button onClick={() => this.setState({ dialogVisible: false })}>关闭</Button>
          </Dialog.Footer>
        </Dialog>
      </div>
    );
  }
}
